import React from "react";
import BusinessImage from "../../../assets/image/businessFuture.svg";
import { sheduleLink } from "../../../constant/Constant";

const BusinessFuture = () => {
  return (
    <section className="w-full my-12 md:my-28 px-10">
      <div className="relative mt-8 md:mt-20 rounded-3xl overflow-hidden h-[19rem] xl:h-[22rem] bg-black">
        <div className="w-full h-full flex z-[1] items-center px-12 py-6">
          <div className="w-full lg:w-7/12 xl:w-1/2 relative">
            <div className="space-y-3 bg-white max-w-[400px] xl:max-w-[490px] 2xl:max-w-[600px] p-8 rounded-3xl">
              <h3
                className={`inline font-Outfit z-0 font-medium text-[32px] text-black relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-4  after:-z-[1] leading-[1.2]`}
              >
                Secure Your Business Future!
              </h3>
              <div className="w-full text-[24px] font-Outfit font-normal text-black">
                SuccessionNow is built on a foundation of over 30 years of
                experience crafting succession plans. See how it can help your
                business.
              </div>
              <div className="flex justify-end items-end">
                <a
                  target="_blank"
                  href={sheduleLink}
                  className={
                    "relative z-0 overflow-hidden flex justify-center items-center gap-2 rounded-full h-10 py-0 px-7 transition-all duration-200 border bg-black after:absolute after:h-full after:content-[''] after:-z-[1] after:top-0 after:left-0 after:transition-[width] after:duration-300 after:ease-in-out after:w-0 hover:after:w-full font-IBM font-medium text-sm xl:text-base border-black  !text-white  after:bg-home-background hover:!border-black hover:!text-black"
                  }
                  rel="noreferrer"
                >
                  Schedule Your Demo
                </a>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-5/12 xl:w-1/2 relative">
            <div className="relative flex justify-center">
              <div className="h-[264px] aspect-auto">
                <img
                  src={BusinessImage}
                  alt="Graph"
                  className="w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessFuture;
